import { PickersDayProps } from '@mui/lab/PickersDay/PickersDay';
import { styled } from '@mui/material/styles';
import { PickersDay } from '@mui/lab';
import * as React from 'react';
import dayjs from 'dayjs';

type CustomPickerDayProps = PickersDayProps<Date> & {
  dayIsBetween: boolean;
  isFirstDay: boolean;
  isLastDay: boolean;
};

const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) =>
    prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay',
})<CustomPickerDayProps>(({ theme, dayIsBetween, isFirstDay, isLastDay }) => ({
  ...(dayIsBetween && {
    borderRadius: 0,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
  ...(isFirstDay && {
    borderRadius: 0,
    borderTopLeftRadius: '50%',
    borderBottomLeftRadius: '50%',
  }),
  ...(isLastDay && {
    borderRadius: 0,
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
  }),
})) as React.ComponentType<CustomPickerDayProps>;

export const getRenderWeekPickerDay = (value: Date | null) =>
  function renderWeekPickerDay(
    date: Date,
    selectedDates: Array<Date | null>,
    pickersDayProps: PickersDayProps<Date>,
  ) {
    if (!value) {
      return <PickersDay {...pickersDayProps} />;
    }

    const start = dayjs(value).startOf('week');
    const end = dayjs(value).endOf('week');

    const dayIsBetween =
      dayjs(date).isAfter(start) && dayjs(date).isBefore(end);
    const isFirstDay = dayjs(date).isSame(start, 'day');
    const isLastDay = dayjs(date).isSame(end, 'day');

    return (
      <CustomPickersDay
        {...pickersDayProps}
        disableMargin
        dayIsBetween={dayIsBetween}
        isFirstDay={isFirstDay}
        isLastDay={isLastDay}
      />
    );
  };
